import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { WarehousePositionForm } from './-form'
import { PageBackButton } from '@/components/common/PageBackButton'
import { Button } from '@/components/ui/button'
import {
    useDeleteWarehousePosition,
    useUpdateWarehousePosition,
    useWarehousePosition,
} from '@/hooks/use-warehouse-position-query'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/warehouse-positions/$id',
)({
    component: WarehousePositionDetailPage,
})

function WarehousePositionDetailPage() {
    const { id } = Route.useParams()
    const navigate = useNavigate()
    const { data: envelope, isLoading } = useWarehousePosition(id)
    const update = useUpdateWarehousePosition(id)
    const remove = useDeleteWarehousePosition()

    const p = envelope?.data

    if (isLoading || !p) {
        return <div className="p-4">{m.warehouse_position_loading()}</div>
    }

    return (
        <div className="space-y-4 page-pad md:space-y-6">
            <div className="flex min-w-0 items-center gap-2">
                <PageBackButton className="-my-2 md:-my-1" />
                <h1 className="text-xl font-semibold">
                    {m.warehouse_position_edit_title()}
                </h1>
            </div>
            <WarehousePositionForm
                submitLabel={m.warehouse_position_submit_save()}
                codeHint={m.warehouse_position_code_edit_warning()}
                showReturnShelf
                showDefectShelf
                defaultValues={{
                    code: p.code,
                    name: p.name ?? '',
                    applicable_lot_types: p.applicable_lot_types,
                    is_return_shelf: p.is_return_shelf,
                    is_pos_shelf: p.is_pos_shelf,
                    is_defect_shelf: p.is_defect_shelf,
                    defect_allow_sale: p.defect_allow_sale,
                }}
                onSubmit={async (data) => {
                    await update.mutateAsync({
                        code: data.code,
                        name: data.name || null,
                        applicable_lot_types: data.applicable_lot_types,
                        is_return_shelf: data.is_return_shelf ?? false,
                        is_pos_shelf: data.is_pos_shelf ?? false,
                        is_defect_shelf: data.is_defect_shelf ?? false,
                        defect_allow_sale: data.is_defect_shelf
                            ? (data.defect_allow_sale ?? false)
                            : false,
                    })
                }}
                footerExtra={
                    p.is_active ? (
                        <Button
                            type="button"
                            variant="destructive"
                            className="flex-1 md:flex-none"
                            onClick={async () => {
                                if (
                                    !confirm(
                                        m.warehouse_position_confirm_delete(),
                                    )
                                )
                                    return
                                await remove.mutateAsync(id)
                                void navigate({
                                    to: '/warehouse-positions',
                                    search: { page: 1 },
                                })
                            }}
                        >
                            {m.warehouse_position_inactive()}
                        </Button>
                    ) : null
                }
            />
        </div>
    )
}
